import cn from 'classnames';
import { useTheme } from 'styled-components';

import { IConDefaultType } from '..';

export enum DefaultImageIconVariant {
  CHAT_SIDE_MENU = 'chat_side_menu',
}

interface IDefaultImageIconProps extends IConDefaultType {
  height?: number;
  variant?: DefaultImageIconVariant;
}

function DefaultImageIcon({
  color,
  className,
  size = 40,
  height,
  rotate,
  flip,
  variant = DefaultImageIconVariant.CHAT_SIDE_MENU,
  style,
}: IDefaultImageIconProps) {
  const theme = useTheme();
  return (
    <i
      className={cn('dds-icon', className, { flip })}
      style={{
        width: size,
        minWidth: size,
        height: height ?? size,
        transform: `rotate(${rotate}deg)`,
        cursor: 'default',
        ...style,
      }}
    >
      {variant === DefaultImageIconVariant.CHAT_SIDE_MENU && (
        <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect x="0.5" y="0.5" width="47" height="47" rx="23.5" fill={theme.color.field.background} />
          <rect x="0.5" y="0.5" width="47" height="47" rx="23.5" stroke={theme.color.line.line_2} />
          <path
            d="M28 14H20C18.4087 14 16.8826 14.6321 15.7574 15.7574C14.6321 16.8826 14 18.4087 14 20V28C14 29.5913 14.6321 31.1174 15.7574 32.2426C16.8826 33.3679 18.4087 34 20 34H28C29.5913 34 31.1174 33.3679 32.2426 32.2426C33.3679 31.1174 34 29.5913 34 28V20C34 18.4087 33.3679 16.8826 32.2426 15.7574C31.1174 14.6321 29.5913 14 28 14ZM16 20C16 18.9391 16.4214 17.9217 17.1716 17.1716C17.9217 16.4214 18.9391 16 20 16H28C29.0609 16 30.0783 16.4214 30.8284 17.1716C31.5786 17.9217 32 18.9391 32 20V28C31.9987 28.2587 31.9719 28.5166 31.92 28.77L28.4 26.54C27.8372 26.1701 27.1785 25.973 26.505 25.973C25.8315 25.973 25.1728 26.1701 24.61 26.54L24.25 26.78C24.0553 26.9151 23.8216 26.9824 23.5849 26.9716C23.3481 26.9607 23.1215 26.8723 22.94 26.72L20.53 24.72C19.9609 24.2488 19.2493 23.9835 18.5107 23.9672C17.772 23.9508 17.0494 24.1844 16.46 24.63L16 25V20ZM28 32H20C18.9391 32 17.9217 31.5786 17.1716 30.8284C16.4214 30.0783 16 29.0609 16 28V27.5L17.67 26.25C17.8939 26.0698 18.1726 25.9716 18.46 25.9716C18.7474 25.9716 19.0261 26.0698 19.25 26.25L21.66 28.25C22.1733 28.6773 22.8113 28.9268 23.4784 28.961C24.1454 28.9953 24.8056 28.8125 25.36 28.44L25.72 28.2C25.9563 28.0405 26.2349 27.9553 26.52 27.9553C26.8051 27.9553 27.0837 28.0405 27.32 28.2L31.05 30.55C30.6781 30.9995 30.2124 31.3622 29.6855 31.6127C29.1587 31.8631 28.5834 31.9953 28 32Z"
            fill={theme.color.line.line_3}
          />
          <path
            d="M26.5 24C25.837 24 25.2011 23.7366 24.7322 23.2678C24.2634 22.7989 24 22.163 24 21.5C24 20.837 24.2634 20.2011 24.7322 19.7322C25.2011 19.2634 25.837 19 26.5 19C27.163 19 27.7989 19.2634 28.2678 19.7322C28.7366 20.2011 29 20.837 29 21.5C29 22.163 28.7366 22.7989 28.2678 23.2678C27.7989 23.7366 27.163 24 26.5 24ZM26.5 21C26.3674 21 26.2402 21.0527 26.1464 21.1464C26.0527 21.2402 26 21.3674 26 21.5C26 21.6326 26.0527 21.7598 26.1464 21.8536C26.2402 21.9473 26.3674 22 26.5 22C26.6326 22 26.7598 21.9473 26.8536 21.8536C26.9473 21.7598 27 21.6326 27 21.5C27 21.3674 26.9473 21.2402 26.8536 21.1464C26.7598 21.0527 26.6326 21 26.5 21Z"
            fill={theme.color.line.line_3}
          />
        </svg>
      )}
    </i>
  );
}

export default DefaultImageIcon;
